import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    createTextVNode as _$ct,
} from 'intact';
import {Tour, TourStep, Button} from 'kpc';

var _$tmp0 = {
    'target': '#btn3',
    'title': '第一步',
    'content': '这是使用子组件方式的第一步说明',
    'position': 'left'
};
var _$tmp1 = {
    'style': 'margin-left: 10px;'
};
var _$tmp2 = {
    'style': 'margin-top: 20px;'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$cc(Button, {
                'id': 'btn3',
                'children': '示例元素1'
            }),
            _$cc(Button, {
                'id': 'btn4',
                'style': 'margin-left: 20px;',
                'children': '示例元素2'
            })
        ], 4 /* HasNonKeyedChildren */, 'example-container'),
        _$cc(Tour, {
            'visible': this.get('showTour'),
            'ev-finish': this.close,
            'children': [
                _$cc(TourStep, _$tmp0),
                _$cc(TourStep, {
                    'target': '#btn4',
                    'title': '第二步',
                    'position': 'top',
                    'children': '这是使用子组件方式的第二步说明'
                })
            ],
            'ev-$model:value': function($v) {
                $this.set('currentStep', $v);
            },
            'value': $this.get('currentStep')
        }),
        _$ce(2, 'div', [
            _$cc(Button, {
                'ev-click': this.settour,
                'children': '\n            启动引导\n        '
            }),
            _$ce(2, 'span', [
                _$ct('\n            当前步骤: '),
                this.get('currentStep') >= 0 ? this.get('currentStep') + 1 : '未启动'
            ], 0 /* UnknownChildren */, null, _$tmp1)
        ], 4 /* HasNonKeyedChildren */, null, _$tmp2)
    ], 4 /* HasNonKeyedChildren */);
};